export default {
    topics: [
        {
            title: ' getAsModel ',
            href: 'sm-seedMember-getAsModel.html',
            attributes: { 'data-id': 'sm-seedMember-getAsModel' },
            menu: { hasChildren: false },
            tocID: 'sm-seedMember-getAsModel-d66e3807',
            topics: [],
        },
    ],
};

